import { useEffect, useId, useSyncExternalStore } from "react";

const entries = new Map<string, string>();
const listeners = new Set<() => void>();

function emit() {
	listeners.forEach((listener) => {
		listener();
	});
}

export function setMetaAdsUnsavedWork(id: string, message: string | null) {
	const prev = entries.get(id) ?? null;
	if (message) {
		if (prev === message) return;
		entries.set(id, message);
	} else {
		if (prev === null) return;
		entries.delete(id);
	}
	emit();
}

export function getMetaAdsUnsavedMessages(): string[] {
	return Array.from(entries.values());
}

function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

function getSnapshot() {
	return getMetaAdsUnsavedMessages().join("\n");
}

/** Subscribe to unsaved-work messages registered by Meta Ads pages. */
export function useMetaAdsUnsavedMessages(): string[] {
	const snapshot = useSyncExternalStore(subscribe, getSnapshot, () => "");
	return snapshot ? snapshot.split("\n") : [];
}

/** Register/unregister an unsaved-work warning while `isDirty` is true. */
export function useRegisterMetaAdsUnsavedWork(
	isDirty: boolean,
	message: string,
) {
	const id = useId();
	useEffect(() => {
		setMetaAdsUnsavedWork(id, isDirty ? message : null);
		return () => setMetaAdsUnsavedWork(id, null);
	}, [id, isDirty, message]);
}
